import { render } from "./DsInput.vue?vue&type=template&id=7ec3bc81&scoped=true"
import script from "./DsInput.vue?vue&type=script&lang=js"
export * from "./DsInput.vue?vue&type=script&lang=js"

import "./DsInput.vue?vue&type=style&index=0&id=7ec3bc81&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec3bc81"]])

export default __exports__